/* eslint-disable no-case-declarations */
import { BellFilled } from '@ant-design/icons';
import { Badge, Popover } from 'antd';
import { memo, useEffect, useState } from 'react';
import { useSocket } from 'src/hooks/useSocket';
import { useAccount, useUnread } from 'src/stores';
import { INotification, SOCKET_EVENTS } from 'src/types';
import NotificationPopover from './NotificationPopover';

function Notification() {
  const [open, setOpen] = useState<boolean>(false);
  const [newItem, setNewItem] = useState<INotification>();
  const socket = useSocket();
  const { account } = useAccount();
  const { changeUnreadNotification, unreadNotification } = useUnread();

  useEffect(() => {
    if (socket) {
      socket.emit(SOCKET_EVENTS.ON_JOIN_NOTIFICATION_ROOM);
      socket.on(SOCKET_EVENTS.NEW_NOTIFICATION, (payload: INotification) => {
        // debounceLoadDevice();
        if (payload.receiver === account?.id) {
          setNewItem(payload);
          !open && changeUnreadNotification(unreadNotification + 1);
        }
      });
    }

    return () => {
      if (socket) {
        socket.emit(SOCKET_EVENTS.ON_LEFT_NOTIFICATION_ROOM);
        socket.off(SOCKET_EVENTS.NEW_NOTIFICATION);
      }
    };
  }, []);

  return (
    <Popover
      placement="bottomRight"
      title={<b style={{ fontSize: '18px' }}>Thông báo</b>}
      trigger="click"
      content={<NotificationPopover newItem={newItem} onClose={() => setOpen(false)} />}
      onOpenChange={(open) => {
        setOpen(open);
        open && changeUnreadNotification(0);
      }}
      arrow={false}
      open={open}
    >
      <Badge count={unreadNotification} offset={[-12, 8]}>
        <div className="icon-wrapper">
          <BellFilled style={{ fontSize: 22 }} />
        </div>
      </Badge>
    </Popover>
  );
}

export default memo(Notification);
